module.exports = __webpack_public_path__ + "static/media/do-not-enter.9828f8fd.svg";